import { Link } from "react-router-dom";

const COLS = [
  {
    title: "Products",
    links: [
      { to: "/products/active-straight", label: "ACTIVE Straight" },
      { to: "/products/active-curved", label: "ACTIVE Curved" },
      { to: "/products/active-outdoor-curved", label: "ACTIVE Outdoor Curved" },
      { to: "/products", label: "Compare Range" },
    ],
  },
  {
    title: "Technologies",
    links: [
      { to: "/technologies/cdrive", label: "CDRIVE™" },
      { to: "/technologies/wsafe", label: "WSAFE™" },
      { to: "/technologies", label: "Future Technologies" },
    ],
  },
  {
    title: "Platform",
    links: [
      { to: "/oem", label: "OEM Manufacturing" },
      { to: "/odm", label: "ODM Development" },
      { to: "/industries", label: "Industries" },
      { to: "/downloads", label: "Download Center" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/company", label: "About ACTIVE" },
      { to: "/news", label: "News" },
      { to: "/contact", label: "Contact" },
      { to: "/contact?type=distributor", label: "Become a Distributor" },
      { to: "/privacy", label: "Privacy & Cookies" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-obsidian text-slate-400 noise-dark" data-testid="footer">
      <div className="relative z-[2] max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10 pb-16 border-b border-white/10">
          <div className="col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img src="/brand/wordmark.png" alt="ACTIVE" className="h-5 w-auto" />
            </div>
            <p className="text-sm leading-relaxed max-w-xs">
              The European stairlift manufacturing platform. Premium products, OEM/ODM development, European rail production and AI-powered dealer tools.
            </p>
            <address className="mt-5 not-italic font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500 leading-relaxed" data-testid="footer-address">
              ACTIVE Stairlifts<br />
              Via Isaac Newton 9A<br />
              20016 Pero MI · Italy
            </address>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-4">{col.title}</p>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                      className="text-sm hover:text-white transition-colors duration-200"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600">
            © 2026 ACTIVE Stairlifts · Designed & Manufactured in Europe
          </p>
          <div className="flex gap-6 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600">
            <span>GDPR Compliant</span>
            <span>EN 81-40 · CE</span>
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-slate-300 transition-colors duration-200">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
